import React, { useEffect, useState } from "react";
import { Accordion, AccordionMenu } from "../../components/Otros/AccordionMenu";
import { Calendario } from "../../components/Otros/Calendario";
import { MenuItem } from "../../components/Otros/MenuItem";
import {
  PlaceholderTabla,
  PlaceholderColumnas,
  PlaceholderInput,
} from "../../components/Otros/Placeholder";
import { InformacionProceso } from "../../components/ProcesosDeCalificacion/InformacionProceso";
import { useFetch } from "../../hooks/useFetch";

import { Tabla } from "../../components/Otros/Tabla";
import { useNavigate, useParams } from "react-router-dom";
import NewWindow from "react-new-window";
import Swal from "sweetalert2";
import { PrecalificadoresAll } from "../../components/Otros/PrecalificadoresAll";

export const Pruebas = () => {
  const handlechange = (fecha) => {
    setFecha(fecha);
  };
  const { nombre } = useParams();
  const [fecha, setFecha] = useState("2021-12-20");

  const navigate = useNavigate();
  const [cuValida, setcuValida] = useState(null);
  const [cuAbierta, setcuAbierta] = useState(false);
  const [precalificador, setprecalificador] = useState(null);

  useEffect(() => {
    if (cuValida != null) {
      if (cuValida) {
        Swal.fire({
          icon: "success",
          title: "Cu validada con éxito",
        }).then(function () {
          navigate("/misEvaluaciones");
        });
      }

      if (!cuValida) {
        Swal.fire({
          icon: "error",
          title:
            "La clave única no corresponde al rut del usuario que ha iniciado sesión.",
        }).then(() => {
          setcuAbierta(false);
          setcuValida(null);
        });
      }
    }
  }, [cuValida]);

  const handleValidarCu = () => {
    console.log("validar cu");
    setcuAbierta(true);
    const dataCu = window.open("/claveUnica/09149120-6");
    var timer = setInterval(function () {
      //console.log(dataCu)
      if (dataCu.closed) {
        clearInterval(timer);
        console.log("se ha cerrado la ventana");
        console.log(dataCu);
        setcuAbierta(false);
      } else {
        try {
          if (dataCu.location.pathname === "/successCu") {
            const pair = dataCu.location.search.replace("?", "").split("=");
            console.log(pair);
            if (pair[3] === "true") {
              setcuValida(true);
            } else {
              setcuValida(false);
            }

            clearInterval(timer);
            dataCu.close();
          }
        } catch (error) {}
      }
    }, 500);
  };

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="toolbar" id="kt_toolbar">
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                Página para testear componentes
              </h1>
              <span className="h-20px border-gray-300 border-start mx-4"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-300 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-dark">TEST</li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    {!cuAbierta ? (
                      <button
                        className="btn btn-primary"
                        onClick={handleValidarCu}
                      >
                        Validar
                      </button>
                    ) : (
                      "Esperando autenticación, no cierre esta página"
                    )}

                    <PrecalificadoresAll
                      idProcess={3}
                      nuevoValue={precalificador}
                      updateValue={setprecalificador}
                    />

                    {typeof nombre != "undefined" && nombre != null ? (
                      <h1>{nombre}</h1>
                    ) : (
                      <></>
                    )}
                    {/*
                    <PlaceholderTabla></PlaceholderTabla>
                    <PlaceholderColumnas columnas={1}></PlaceholderColumnas>
                    <PlaceholderColumnas columnas={2}></PlaceholderColumnas>
                    <PlaceholderColumnas columnas={3}></PlaceholderColumnas>
                    <PlaceholderColumnas columnas={4}></PlaceholderColumnas>
                    <PlaceholderColumnas columnas={5}></PlaceholderColumnas>
                    <PlaceholderInput></PlaceholderInput>
                    <div className="form-group">
                      <label>fecha</label>

                      <Calendario
                        value={fecha}
                        name="fecha12"
                        id="fecha12"
                        disabled="false"
                        className="form-control mb-5"
                        onChanges={handlechange}
                      />
                    </div>

                    <div className="form-group">
                      <AccordionMenu
                        icon="fas fa-upload"
                        titulo="Acordión de prueba"
                      >
                        <MenuItem to="/pruebas">Ir a pruebas</MenuItem>
                      </AccordionMenu>
                    </div>
  
  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
